export const COMPANY = {
  name: "Gabana Management SA",
  tagline: "Conseil en gestion, stratégie & gouvernance",
  address: "Rue de la Faïencerie 6, 1227 Carouge GE, Suisse",
  email: "info@gabana-management.com",
  website: "www.gabana-management.com",
  linkedin: "https://www.linkedin.com/company/gabana-management-sa",
  crunchbase: "https://www.crunchbase.com/organization/gabana-management-sa",
  hours: "Lun – Ven, 9 h à 18 h",
  regNumber: "CH-320.3.047.034-1",
  tva: "CHE-105.260.170",
  registered: "19.10.1999",
  ceo: "Rolf Hauri",
  founder: "Agda Maria Atala Hauri",
  coordinates: "46.1844° N — 6.1390° E",
};
